module.exports = __webpack_public_path__ + "img/module-bg.9bcaa0e4.jpg";